import { createDCHook, createMutationHook, collapseDataFromCall, collapseParams } from '../client';
import { getAddressPublic, getAddressCharacteristics, getAddressBusinessCheck } from '../services/AddressPublicService';

export const useAddressPublicGetAddressPublic = createDCHook(
  'getAddressPublic',
  collapseDataFromCall(getAddressPublic),
  { injectables: ['label', 'businessUnit'], flattenData: true },
);

export const useAddressPublicGetAddressCharacteristics = createMutationHook(
  collapseDataFromCall(
    collapseParams(
      collapseParams(getAddressCharacteristics, 'requestBody', 'data'),
      'data',
      'postalCode',
      'houseNumber',
      'houseNumberSuffix',
    ),
  ),
  {
    injectables: ['label', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['postalCode', 'houseNumber', 'houseNumberSuffix'] },
    ],
  },
);

export const useAddressPublicGetAddressBusinessCheck = createDCHook(
  'getAddressBusinessCheck',
  collapseDataFromCall(getAddressBusinessCheck),
  { injectables: ['label', 'businessUnit'], flattenData: true },
);
